import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import useQuestionnaireStore from '../store/useQuestionnaireStore.js';
import useWarning from '../hooks/useWarningModal.js';
import { ChevronLeft } from 'lucide-react';
import Button from '../components/common/Button';

// Data for the duration options
const durationOptions = [
    { value: '0-6 weeks', label: '0 - 6 Weeks', sublabel: '(Acute)' },
    { value: '6-12 weeks', label: '6 - 12 Weeks', sublabel: '(Subacute)' },
    { value: '12+ weeks', label: 'More than 12 Weeks', sublabel: '(Chronic)' },
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.15 },
    },
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
};

const Step4_Duration = () => {
    const navigate = useNavigate();
    const { setPainDuration, painDuration: selectedDuration } = useQuestionnaireStore();
    const showWarning = useWarning();

    const handleSelect = (value) => {
        setPainDuration(value);
    };

    const handleNext = () => {
        if (selectedDuration) {
            console.log("Selected Pain Duration:", selectedDuration);
            navigate('/step-5');
        } else {
            showWarning('Please select a duration.');
        }
    };

    return (
        <motion.div
            className="page step4-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="step-header">
                <button onClick={() => navigate(-1)} className="back-button">
                    <ChevronLeft size={24} /> Back
                </button>
                <h2>How long have you had this pain?</h2>
            </div>

            <motion.div 
                className="duration-options-container"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {durationOptions.map((option) => (
                    <motion.button
                        key={option.value}
                        className={`duration-card ${selectedDuration === option.value ? 'selected' : ''}`}
                        onClick={() => handleSelect(option.value)}
                        variants={itemVariants}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.98 }}
                    >
                        <span className="duration-label">{option.label}</span>
                        <span className="duration-sublabel">{option.sublabel}</span>
                    </motion.button>
                ))}
            </motion.div>

            <div className="navigation-buttons">
                <Button onClick={handleNext}>Next</Button>
            </div>
        </motion.div>
    );
};

export default Step4_Duration;

